import React,{ useState } from "react";

export default () => {
  const [isSowMobileMenu, setIsSowMobileMenu] = useState(false); 
  
  //let isSowMobileMenu=false;
  const showMobileMenu = (value) => {
    console.log("Button clicked!");
    // Add more logic here
    setIsSowMobileMenu(value);
    //this.isSowMobileMenu=true;
  };
  return (
      <>
        <div className={ isSowMobileMenu==true ? 'mobile-menu-visible' : ''}>
          <header class="mkt_main-header">
              <div class="header-lower">
                  <div class="outer-box">
                      <div class="logo-box">
                          <figure class="logo"><a href="/">
                            <img src="assets/img/grspaces.jpeg" alt=""/></a></figure>
                      </div>
                      <div class="menu-area">
                          <div class="mobile-nav-toggler" onClick={() => showMobileMenu(true)}>
                              <i class="icon-bar"></i>
                              <i class="icon-bar"></i>
                              <i class="icon-bar"></i>
                          </div>
                          <nav class="main-menu navbar-expand-md navbar-light clearfix">
                              <div class="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                                  <ul class="navigation clearfix">
                                      <li class="current"><a href="/">Home</a>
                                          
                                      </li> 
                                      <li><a href="/#About">About</a> </li> 
                                      <li><a href="/#Services">Services</a>
                                          
                                      </li> 
                                      {/*<li><a href="portfolio.html">Portfolio</a></li> 
                                      <li class="dropdown"><a href="index.html">Blog</a>
                                          <ul>
                                              <li><a href="blog.html">Blog List</a></li>
                                              <li><a href="blog-details.html">Blog Details</a></li>
                                          </ul>
                                      </li> */ }
                                      <li><a href="/#Contact">Contact</a></li> 
                                  </ul>
                              </div>
                          </nav>                      
                      </div>
                      <ul class="menu-right-content">
                          <li class="quote-btn">
                              <a href="/#Contact" class="theme-btn btn-style-two">
                                  <span class="txt">Get Free Quote</span>
                              </a>
                          </li>
                          <li class="search-box-outer search-toggler">
                              <a href="#"><i class="fa-light fa-magnifying-glass"></i></a>
                          </li>
                          <li class="offcanvas-box">
                              <div class="option-item">
                                  <a href="#" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight"> <i class="fa-thin fa-bars-sort"></i></a>
                              </div>
                          </li>
                      </ul>
                  </div>
              </div>

              <div class="sticky-header">
                  <div class="outer-container">
                      <div class="outer-box">
                          <div class="logo-box">
                              <figure class="logo"><a href="/">
                                <img src="assets/img/logo-white.png" alt=""/></a></figure>
                          </div>
                          <div class="menu-area">
                              <nav class="main-menu clearfix">
                                  {/** menu comes from javascript */}
                                  <div class="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                                    <ul class="navigation clearfix">
                                        <li class="current"><a href="/">Home</a>
                                            
                                        </li> 
                                        <li><a href="/#About">About</a> </li> 
                                        <li><a href="/#Services">Services</a>
                                            
                                        </li> 
                                        {/*<li><a href="portfolio.html">Portfolio</a></li> 
                                        <li class="dropdown"><a href="index.html">Blog</a>
                                            <ul>
                                                <li><a href="blog.html">Blog List</a></li>
                                                <li><a href="blog-details.html">Blog Details</a></li>
                                            </ul>
                                        </li> */ }
                                        <li><a href="/#Contact">Contact</a></li> 
                                    </ul>
                                </div>
                              </nav>
                              <ul class="menu-right-content">
                                  <li class="search-box-outer search-toggler">
                                      <a href="#"><i class="fa-light fa-magnifying-glass"></i></a>
                                  </li>
                                  <li class="offcanvas-box">
                                      <div class="option-item">
                                          <a href="#" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight"> <i class="fa-thin fa-bars-sort"></i></a>
                                      </div>
                                  </li>
                              </ul>
                          </div>
                      </div>
                  </div>
              </div>
          </header>
          <div class="mobile-menu">
            <div class="menu-backdrop"></div>
            <div class="close-btn" onClick={() => showMobileMenu(false)} ><i class="fas fa-times"></i></div>
            
            <nav class="menu-box ">
                <div class="nav-logo"><a href="/"><img src="assets/img/grspaces.jpeg" alt=""/></a></div>
                <div class="menu-outer">{/*Mobile Menu Will Come From Js*/}
                <div class="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                                  <ul class="navigation clearfix">
                                      <li class="current"><a href="/">Home</a>
                                          
                                      </li> 
                                      <li><a href="/#About">About</a> </li> 
                                      <li><a href="/#Services">Services</a>
                                          
                                      </li> 
                                      {/*<li><a href="portfolio.html">Portfolio</a></li> 
                                      <li class="dropdown"><a href="index.html">Blog</a>
                                          <ul>
                                              <li><a href="blog.html">Blog List</a></li>
                                              <li><a href="blog-details.html">Blog Details</a></li>
                                          </ul>
                                      </li> */ }
                                      <li><a href="/#Contact">Contact</a></li> 
                                  </ul>
                              </div>                          
                </div> 
            </nav>
          </div>
      </div>
      </>
  );
};
